export const useTwicPicsBlogUrl = (url?: string) => url ? `/blog${url}` : null
